var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgPlayFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.409 21C4.564 21 4 20.389 4 19.433V4.567C4 3.61 4.564 3 5.409 3c.458 0 .833.156 1.315.411l12.996 7.122c.94.511 1.28.878 1.28 1.467 0 .589-.34.956-1.28 1.467L6.724 20.589c-.482.255-.857.411-1.315.411z",
    fill: "currentColor"
  })));
}

export default SvgPlayFill;